import { storyblokEditable } from "@storyblok/react";
import ahoy from "@lib/ahoy";
import { analytics } from "@lib/trackers/analytics";
import { usePathname } from "@lib/i18n/navigation-app-router";
import { useCurrentUser } from "@hooks/use-current-user";
import Link from "@components/core/Link";
import StoryblokImage from "@components/core/Storyblok/StoryblokImage";

function CollectionList6({ blok }) {
  const pathname = usePathname();
  const user = useCurrentUser();
  const userGroup = user?.user_group;

  function sendTrackerData(collectionLink) {
    const defaultEventData = {
      tracking_name: "homeCollectionList6",
      page: pathname,
      collection_link: collectionLink,
      user_group: userGroup,
    };

    ahoy("$click", defaultEventData);
    analytics.track("$click", defaultEventData);
  }

  if (!blok) return null;

  return (
    <section
      key={blok._uid}
      {...storyblokEditable(blok)}
      className="storyblok-home-section"
    >
      <div className="collection-list-6-container">
        {Array.from({ length: 6 }, (_, index) => (
          <section
            className="collection-image-container"
            key={`collection_id_${index + 1}`}
          >
            <Link
              href={blok[`collection_link_${index + 1}`]?.url}
              prefetch={false}
              onClick={() => sendTrackerData(blok[`collection_link_${index + 1}`]?.url)}
            >
              <StoryblokImage
                className="collection-image"
                alt={blok[`collection_image_${index + 1}`]?.alt}
                src={blok[`collection_image_${index + 1}`]?.filename}
                sizes="(min-width: 768px) 33vw, 100vw"
              />
            </Link>
          </section>
        ))}
      </div>
    </section>
  );
}

export default CollectionList6;
